import { api } from "./client";

export interface PerformanceFilters {
  start_date: string | null;
  end_date: string | null;
  start_datetime: string | null;
  end_datetime: string | null;
  flight_limit: number | null;
  pilot_id: number | null;
}

export interface PerformancePilot {
  id: number;
  username: string;
  account_type: string;
  flight_count: number;
}

export interface PerformanceMissionSummary {
  flight_count: number;
  matching_flight_count: number;
  total_flight_count: number;
  window_label: string;
  mission_window_label: string;
  owner_scope: string;
}

export interface PerformanceFlightRow {
  flight_id: number;
  session_name: string;
  owner_label: string | null;
  map_name: string | null;
  date_display: string;
  date_value: string;
  time_window_display: string;
  axis_label: string;
  avg_speed_kmh: number | null;
  avg_speed_display: string;
  distance_km: number | null;
  distance_display: string;
  peak_g: number | null;
  peak_g_display: string;
  battery_spent_pct: number | null;
  battery_spent_display: string;
  smoothness_score: number | null;
  smoothness_display: string;
  duration_min: number | null;
  duration_display: string;
  // Extra metrics used by the widgetized Performance dashboard.
  min_speed_kmh?: number | null;
  max_speed_kmh?: number | null;
  min_altitude_m?: number | null;
  avg_altitude_m?: number | null;
  max_altitude_m?: number | null;
  total_climb_m?: number | null;
  total_descent_m?: number | null;
  max_vertical_rate_mps?: number | null;
  min_vertical_rate_mps?: number | null;
  max_turn_rate_deg_s?: number | null;
  hover_ratio?: number | null;
}

export interface PerformanceCardPoint {
  axis_label: string;
  date_label: string;
  session_name: string;
  value: number | null;
  display_value: string;
}

export interface PerformanceCard {
  key: string;
  title: string;
  description: string;
  digits: number;
  suffix: string;
  average_value: number | null;
  average_display: string;
  trend_direction: string;
  trend_text: string;
  color: string;
  points: PerformanceCardPoint[];
}

export interface PerformanceOut {
  missions: string[];
  selected_mission: string | null;
  pilots: PerformancePilot[];
  can_pick_pilot: boolean;
  filters: PerformanceFilters;
  summary: PerformanceMissionSummary;
  flight_rows: PerformanceFlightRow[];
  cards: PerformanceCard[];
}

export function getPerformance(params: Record<string, string | number | undefined>) {
  const qs = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value === undefined || value === null || value === "") continue;
    qs.set(key, String(value));
  }
  const suffix = qs.toString() ? `?${qs.toString()}` : "";
  return api.get<PerformanceOut>(`/api/performance${suffix}`);
}
